import React , { useState }  from 'react';
import './popUpStart.css'
import ButtonPopUp from '../buttonPopUp/buttonPopUp';

export interface IPopUpStart{

  closePopup?:()=> void;
}

export const PopUpStart :React.FC<IPopUpStart> = ({closePopup}) => {
    const imgBox: string = require("../../../assets/img_box.svg").default;

  
  return (
    <>
    <div className="popup-box">
    <div className="box">
    <div className="popup-box">
      <div className="box">
      <div className="imgBox">
      <img src={imgBox} alt=" Spb" className="image-popup" />
      </div>
      <div className=" textBox align-items-center ">
      La renonciation est possible sans aucune justification dans un délai de 30 jours calendaires à compter de la date d’adhésion. <br/>La résiliation implique le respect d'un préavis et a pour conséquence de  <br/>faire cesser les garanties d'assurance couvrant votre bien à partir de la<br/> date d'effet de cette résiliation.
     <br/> Veuillez vous munir de votre contrat pour procéder à votre demande.
        </div>
       <div className='boxButton'>
       <ButtonPopUp type="submit" className='buttonPopUp'  onClick={closePopup}>
       J'ai compris !
       </ButtonPopUp>
        </div> 
      </div>
    </div>
    </div>
  </div>

  </>
    
  )
}

export default PopUpStart;